export const BATCH_PAYOUTS_TABLE_TEST_ID = 'batch-payouts-table';
export const BATCH_PAYOUTS_DRAFTS_TABLE_TEST_ID = 'batch-payouts-draft-table';
